import React from 'react';
import Icon, { IconProps } from '../Icon';

const PencilCircleFilled: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d)">
          <circle cx="19" cy="19" r="16" fill="white" />
          <path
            d="M19 3C10.1616 3 3 10.1616 3 19C3 27.8384 10.1616 35 19 35C27.8384 35 35 27.8384 35 19C35 10.1616 27.8384 3 19 3ZM14.3664 26.52L11 26.9872L11.4864 23.6208L21.816 13.2848L24.7216 16.1712L14.3664 26.52ZM25.3104 15.5888L22.424 12.7024L24.1136 11.0128L27 13.8992L25.3104 15.5888Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="0"
            y="0"
            width="100%"
            height="100%"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="4" dy="4" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Icon>
  );
};
export default PencilCircleFilled;
